// extracted by mini-css-extract-plugin
export default {"content":"IdleStage_content__z5mRD","example":"IdleStage_example__cdCHZ"};